<template>
  <v-form class='createWelderForm' v-model='valid' ref='createWelderForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='welder.name'
            :error-messages='error.name'
            label='Name'
            placeholder='Welder Name'
            ref="firstInput"
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='welder.passcode'
            :error-messages='error.passcode'
            label='Passcode'
            placeholder='Passcode'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='welder.qualification'
            :error-messages='error.qualification'
            label='Qualification'
            placeholder='Qualification'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <label class="c-radio-label">Rating</label>
          <v-rating
          v-model='welder.rating'
          hover
          length="5"
          size="22"
          ></v-rating>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='welder.experience'
            :error-messages='error.experience'
            label='Experience'
            placeholder='Experience'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='welder.salary'
            :error-messages='error.salary'
            label='Salary/Hour'
            placeholder='Salary/Hour'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="welder.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.getDataById(id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        this.getDataById(_storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      welder: { status: 0 },
      error: {}
    }
  },
  methods: {
    getDataById (id) {
      this.$axios.post('getWelderById/' + id).then((res) => {
        this.welder = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveWelder/' + this.edit_id : 'saveWelder'
        this.$axios.post(route, this.welder).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/welder')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createWelderForm.validate()
      }
    },
    reset () {
      this.$refs.createWelderForm.reset()
      setTimeout(() => {
        this.welder = { status: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>

<style>
.createWelderForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createWelderForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
